import { useAuth } from "@/auth/AuthContext";
import { Button } from "@mantine/core";
import { useState } from "react";
import { NavLink } from "react-router-dom";

export function SignupButtons() {
  const { loginWithKakao } = useAuth();
  const [isLoading, setIsLoading] = useState(false);

  // TODO: finish creating kakao signup flow
  const loginWithKakaoAndHandleError = async () => {
    setIsLoading(true);
    const error = await loginWithKakao();
    setIsLoading(false);
    if (error) {
      alert(error.message);
    }
    return error;
  };
  return (
    <>
      <Button
        size="lg"
        fullWidth
        variant="default"
        radius="xl"
        onClick={loginWithKakaoAndHandleError}
        loading={isLoading}
        disabled={isLoading}
      >
        카카오 가입하기
      </Button>
      <Button
        component={NavLink}
        to="/signup/email"
        size="lg"
        fullWidth
        variant="default"
        radius="xl"
        loading={isLoading}
        disabled={isLoading}
      >
        이메일 가입하기
      </Button>
    </>
  );
}
